import { render, staticRenderFns } from "./DonationsList.vue?vue&type=template&id=cd337b8e"
import script from "./DonationsList.vue?vue&type=script&lang=js"
export * from "./DonationsList.vue?vue&type=script&lang=js"
import style0 from "./DonationsList.vue?vue&type=style&index=0&id=cd337b8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports